import React, { memo } from "react";
import brandLogo from "@/assets/images/logo.png";

const ChatHeader = memo(() => {
  return (
    <>
      <div className="w-full flex justify-center items-center mb-2">
        <img src={brandLogo} alt="chatIcon" className="w-[20px] h-[35px] object-contain" />
      </div>
      <h1 className="font-semibold leading-[38px] text-center text-[1.763rem] text-gray-800 dark:text-gray-100">
        What would you like to do?
      </h1>
      <p className="text-[0.793rem] font-sans leading-[1.125rem] text-center text-gray-500 dark:text-gray-400">
        Select a prompt or start your own to start chatting
      </p>
    </>
  );
});

export default ChatHeader;
